import { format } from 'date-fns';

import { RangeSelectorType } from 'modules/api/const';

const DEFAULT_MAIN_DAYS = {
  [RangeSelectorType.Week]: 7,
  [RangeSelectorType.Month]: 30,
  [RangeSelectorType.SixMonths]: 180,
} as const;

export function getMainDays(range: RangeSelectorType): number {
  return DEFAULT_MAIN_DAYS[range] ?? DEFAULT_MAIN_DAYS[RangeSelectorType.Week];
}

export function formatDate(date: Date, range: RangeSelectorType): string {
  switch (range) {
    case RangeSelectorType.SixMonths:
      return format(date, 'MMM yyyy');
    case RangeSelectorType.Month:
      return format(date, 'dd MMM yyyy');
    case RangeSelectorType.Week:
    default:
      return format(date, 'd MMM yyyy');
  }
}
